export const translations = {
  id: {
    translation: {
      // Header
      nav: {
        home: 'Beranda',
        about: 'Tentang',
        activities: 'Kegiatan',
        gallery: 'Galeri',
        contact: 'Kontak',
        joinAction: 'Gabung Aksi'
      },
      
      // Hero Section
      hero: {
        badge: 'Platform Aksi Sosial Anak Muda',
        title: 'Merdeka dengan Aksi Nyata',
        subtitle: 'Platform aksi sosial anak muda untuk perubahan yang berarti',
        viewActivities: 'Lihat Kegiatan',
        joinAction: 'Gabung Aksi',
        stats: {
          volunteers: 'Relawan Aktif',
          activities: 'Kegiatan Sosial',
          helped: 'Orang Terbantu'
        },
        card: {
          title: 'Aksi Nyata',
          subtitle: 'Perubahan Dimulai dari Kita'
        }
      },
      
      // About Section
      about: {
        title: 'Tentang Merdekaku.id',
        description: 'Merdekaku.id adalah platform aksi sosial yang digerakkan oleh anak muda Indonesia. Kami percaya bahwa perubahan nyata dimulai dari tindakan nyata, bukan hanya kata-kata. Melalui platform ini, kami menghubungkan anak muda yang peduli dengan aksi sosial yang berdampak langsung kepada masyarakat.',
        features: {
          impact: {
            title: 'Fokus Dampak Nyata',
            desc: 'Setiap kegiatan dirancang untuk memberikan manfaat langsung kepada masyarakat yang membutuhkan.'
          },
          collaboration: {
            title: 'Kolaborasi Anak Muda',
            desc: 'Menggerakkan generasi muda untuk bersama-sama menciptakan perubahan positif.'
          },
          transparency: {
            title: 'Transparansi Penuh',
            desc: 'Dokumentasi lengkap setiap kegiatan untuk memastikan akuntabilitas dan kepercayaan.'
          }
        },
        vision: {
          title: 'Visi Kami',
          desc: 'Menjadi platform terdepan yang menginspirasi dan memberdayakan anak muda Indonesia untuk menciptakan dampak sosial yang berkelanjutan.'
        }
      },
      
      // Featured Project
      project: {
        badge: 'Featured Project',
        title: 'Project Pertama: Kunjungan & Bakti Sosial ke Panti Asuhan',
        description: 'Kolaborasi dengan siswa-siswi kelas XII untuk mengadakan kunjungan dan bakti sosial ke panti asuhan. Kegiatan ini meliputi penggalangan dana, pengadaan sembako dan kebutuhan sehari-hari, serta kunjungan langsung untuk berinteraksi dengan anak-anak panti.',
        date: 'Desember 2024',
        location: 'Panti Asuhan Harapan Bangsa, Jakarta',
        detailsTitle: 'Rincian Kegiatan:',
        details: [
          'Penggalangan dana bersama siswa',
          'Pengadaan sembako dan perlengkapan',
          'Kunjungan dan interaksi langsung',
          'Dokumentasi kegiatan untuk transparansi'
        ],
        stats: {
          volunteers: 'Relawan Terlibat',
          children: 'Anak Terbantu'
        },
        cta: 'Lihat Dokumentasi Lengkap'
      },
      
      // Gallery
      gallery: {
        title: 'Dokumentasi Kegiatan',
        subtitle: 'Lihat momen-momen inspiratif dari berbagai kegiatan sosial yang telah kami lakukan bersama',
        loadMore: 'Lihat Lebih Banyak',
        close: 'Tutup',
        captions: [
          'Gotong royong mewarnai fasilitas umum',
          'Aksi bersih lingkungan',
          'Pengumpulan donasi',
          'Distribusi bantuan ke masyarakat',
          'Penggalangan dana lewat acara musik',
          'Kunjungan ke komunitas lokal'
        ]
      },
      
      // How It Works
      howItWorks: {
        title: 'Cara Kerja Kami',
        subtitle: 'Proses sederhana untuk menciptakan dampak sosial yang nyata dan berkelanjutan',
        steps: [
          {
            title: 'Ide Kegiatan Sosial',
            desc: 'Identifikasi masalah sosial dan susun rencana kegiatan yang berdampak'
          },
          {
            title: 'Galang Dana Bersama',
            desc: 'Kumpulkan dana dan sumber daya dari komunitas yang peduli'
          },
          {
            title: 'Eksekusi di Lapangan',
            desc: 'Jalankan kegiatan sosial secara langsung dengan tim relawan'
          },
          {
            title: 'Dokumentasi & Publikasi',
            desc: 'Bagikan hasil dan dampak kegiatan untuk transparansi dan inspirasi'
          }
        ],
        ready: 'Siap memulai aksi sosial Anda sendiri?',
        startActivity: 'Mulai Kegiatan Sosial'
      },
      
      // CTA Section
      cta: {
        badge: 'Jadilah Bagian dari Perubahan',
        title: 'Mari Ciptakan Dampak\nBersama-sama',
        description: 'Bergabunglah dengan komunitas anak muda yang peduli dan berkomitmen untuk menciptakan perubahan nyata di masyarakat. Setiap aksi kecil, bermakna besar.',
        contact: 'Hubungi Kami',
        viewAll: 'Lihat Semua Kegiatan',
        trust: {
          transparent: 'Transparan',
          volunteers: 'Relawan Aktif',
          support: 'Dukungan'
        }
      },
      
      // Contact Form
      contact: {
        badge: 'Hubungi Kami',
        title: 'Mari Berkolaborasi',
        description: 'Punya ide kegiatan sosial atau ingin bergabung dalam aksi kami? Hubungi kami!',
        features: [
          {
            title: 'Respons Cepat',
            desc: 'Kami akan merespons pesan Anda dalam 1-2 hari kerja'
          },
          {
            title: 'Kolaborasi Terbuka',
            desc: 'Kami terbuka untuk berbagai bentuk kerja sama dan ide'
          },
          {
            title: 'Dukungan Penuh',
            desc: 'Tim kami siap membantu mewujudkan ide aksi sosial Anda'
          }
        ],
        form: {
          name: 'Nama Lengkap',
          email: 'Email',
          phone: 'Nomor Telepon',
          subject: 'Subjek',
          message: 'Pesan',
          namePlaceholder: 'Masukkan nama lengkap Anda',
          emailPlaceholder: 'nama@email.com',
          phonePlaceholder: '+62 812-3456-7890',
          subjectPlaceholder: 'Topik pesan Anda',
          messagePlaceholder: 'Ceritakan ide atau pertanyaan Anda...',
          sending: 'Mengirim...',
          send: 'Kirim Pesan',
          success: 'Pesan berhasil dikirim! Kami akan segera menghubungi Anda.'
        }
      },
      
      // Footer
      footer: {
        about: 'Merdekaku.id adalah platform aksi sosial anak muda untuk menciptakan perubahan nyata di masyarakat.',
        quickLinks: 'Menu Cepat',
        contactTitle: 'Kontak',
        stayConnected: 'Tetap Terhubung',
        stayConnectedDesc: 'Ikuti perkembangan kegiatan sosial kami melalui media sosial',
        emailUs: 'Email Kami',
        responseTime: 'Respons dalam 1-2 hari',
        copyright: 'Merdekaku.id. Semua hak dilindungi.',
        privacy: 'Kebijakan Privasi',
        terms: 'Syarat & Ketentuan'
      }
    }
  },
  
  en: {
    translation: {
      // Header
      nav: {
        home: 'Home',
        about: 'About',
        activities: 'Activities',
        gallery: 'Gallery',
        contact: 'Contact',
        joinAction: 'Join Action'
      },
      
      // Hero Section
      hero: {
        badge: 'Youth Social Action Platform',
        title: 'Freedom through Real Action',
        subtitle: 'Youth social action platform for meaningful change',
        viewActivities: 'View Activities',
        joinAction: 'Join Action',
        stats: {
          volunteers: 'Active Volunteers',
          activities: 'Social Activities',
          helped: 'People Helped'
        },
        card: {
          title: 'Real Action',
          subtitle: 'Change Starts with Us'
        }
      },
      
      // About Section
      about: {
        title: 'About Merdekaku.id',
        description: 'Merdekaku.id is a social action platform driven by Indonesian youth. We believe that real change begins with real action, not just words. Through this platform, we connect caring young people with social actions that directly impact the community.',
        features: {
          impact: {
            title: 'Focus on Real Impact',
            desc: 'Every activity is designed to provide direct benefits to communities in need.'
          },
          collaboration: {
            title: 'Youth Collaboration',
            desc: 'Mobilizing young people to create positive change together.'
          },
          transparency: {
            title: 'Full Transparency',
            desc: 'Complete documentation of every activity to ensure accountability and trust.'
          }
        },
        vision: {
          title: 'Our Vision',
          desc: 'To become the leading platform that inspires and empowers Indonesian youth to create sustainable social impact.'
        }
      },
      
      // Featured Project
      project: {
        badge: 'Featured Project',
        title: 'First Project: Visit & Social Service to Orphanage',
        description: 'Collaboration with 12th grade students to organize visits and social services to orphanages. This activity includes fundraising, procurement of basic necessities, and direct visits to interact with orphanage children.',
        date: 'December 2024',
        location: 'Harapan Bangsa Orphanage, Jakarta',
        detailsTitle: 'Activity Details:',
        details: [
          'Fundraising with students',
          'Procurement of groceries and supplies',
          'Direct visit and interaction',
          'Activity documentation for transparency'
        ],
        stats: {
          volunteers: 'Volunteers Involved',
          children: 'Children Helped'
        },
        cta: 'View Full Documentation'
      },
      
      // Gallery
      gallery: {
        title: 'Activity Documentation',
        subtitle: 'See inspiring moments from various social activities we have done together',
        loadMore: 'Load More',
        close: 'Close',
        captions: [
          'Community painting public facilities',
          'Environmental cleanup action',
          'Donation collection',
          'Aid distribution to community',
          'Fundraising through music events',
          'Visit to local community'
        ]
      },
      
      // How It Works
      howItWorks: {
        title: 'How We Work',
        subtitle: 'Simple process to create real and sustainable social impact',
        steps: [
          {
            title: 'Social Activity Idea',
            desc: 'Identify social issues and plan impactful activities'
          },
          {
            title: 'Fundraise Together',
            desc: 'Collect funds and resources from caring community'
          },
          {
            title: 'Execute in Field',
            desc: 'Carry out social activities directly with volunteer team'
          },
          {
            title: 'Document & Publish',
            desc: 'Share results and impact for transparency and inspiration'
          }
        ],
        ready: 'Ready to start your own social action?',
        startActivity: 'Start Social Activity'
      },
      
      // CTA Section
      cta: {
        badge: 'Be Part of the Change',
        title: 'Let\'s Create Impact\nTogether',
        description: 'Join a community of caring and committed young people to create real change in society. Every small action has great meaning.',
        contact: 'Contact Us',
        viewAll: 'View All Activities',
        trust: {
          transparent: 'Transparent',
          volunteers: 'Active Volunteers',
          support: 'Support'
        }
      },
      
      // Contact Form
      contact: {
        badge: 'Contact Us',
        title: 'Let\'s Collaborate',
        description: 'Have a social activity idea or want to join our actions? Contact us!',
        features: [
          {
            title: 'Quick Response',
            desc: 'We will respond to your message within 1-2 business days'
          },
          {
            title: 'Open Collaboration',
            desc: 'We are open to various forms of cooperation and ideas'
          },
          {
            title: 'Full Support',
            desc: 'Our team is ready to help realize your social action ideas'
          }
        ],
        form: {
          name: 'Full Name',
          email: 'Email',
          phone: 'Phone Number',
          subject: 'Subject',
          message: 'Message',
          namePlaceholder: 'Enter your full name',
          emailPlaceholder: 'name@email.com',
          phonePlaceholder: '+62 812-3456-7890',
          subjectPlaceholder: 'Your message topic',
          messagePlaceholder: 'Tell us your ideas or questions...',
          sending: 'Sending...',
          send: 'Send Message',
          success: 'Message sent successfully! We will contact you soon.'
        }
      },
      
      // Footer
      footer: {
        about: 'Merdekaku.id is a youth social action platform to create real change in society.',
        quickLinks: 'Quick Links',
        contactTitle: 'Contact',
        stayConnected: 'Stay Connected',
        stayConnectedDesc: 'Follow our social activity developments through social media',
        emailUs: 'Email Us',
        responseTime: 'Response in 1-2 days',
        copyright: 'Merdekaku.id. All rights reserved.',
        privacy: 'Privacy Policy',
        terms: 'Terms & Conditions'
      }
    }
  }
};
